import * as React from "react";
import Box from "@mui/material/Box";
import CardContent from "@mui/material/CardContent";
import Header from "./Header/Header";
import Label from "./Label/Label";
import svg from "../assets/jpg/PageNotFound.jpg";
import { Grid } from "@mui/material";
import Buttons from "./Controls/Buttons/Button";
import { useNavigate } from "react-router-dom";
import "./pageNotFound.scss";
import { preProRoutes, proRoutes, valiRoutes } from "../routes/routeConstants";

const PageNotFound = () => {
  const navigate = useNavigate();
  const handleHome = () => {
    if (
      localStorage.getItem("token") === null ||
      localStorage.getItem("userRole") === null
    ) {
      navigate("/");
    } else if (localStorage.getItem("userRole") === "pre-processor") {
      navigate(`/${preProRoutes.preProDashboard}`)
    } else if (localStorage.getItem("userRole") === "processor") {
      navigate(`/${proRoutes.proDashboard}`)
    } else if (localStorage.getItem("userRole") === "validator") {
      navigate(`/${valiRoutes.valiDashboard}`)
    }
  };
  return (
    <React.Fragment>
      <Header />
      <>
        <Grid container className="main-pageNotFound-container">
          <Grid item xs={6}>
            <Box className="pageNotFound-data">
              <CardContent className="pageNotFound-card">
                <div className="card-info-wrap">
                  <Label
                    component="div"
                    text="404"
                    fontSize="200px"
                    fontWeight="600"
                    lineHeight="200px"
                    color="var(--color-black)"
                  />
                  <Label
                    fontSize="50px"
                    fontWeight="600"
                    lineHeight="78.02px"
                    color="var(--color-black)"
                    text="ooops..."
                  />
                  <Label
                    fontSize="40px"
                    fontWeight="300"
                    lineHeight="68px"
                    color="var(--color-black)"
                    text="Page Not Found"
                  />
                  <Label
                    fontWeight="600"
                    fontSize="18px"
                    padding="20px 0px 0px 0px"
                    color="#2D4642"
                    text="Sorry. The content you're looking for doesn't exist."
                  />
                  <Label
                    fontWeight="600"
                    fontSize="18px"
                    padding="0px 0px 20.94px 0px"
                    color="#2D4642"
                    text="Either it was removed, or you mistyped the link"
                  />
                </div>
                <div className="go-back-btn">
                  <Buttons
                    text="Go Back"
                    size="large"
                    margin="0px !important"
                    onClick={() => handleHome()}
                  />
                </div>
              </CardContent>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="pageNotFound-icon">
              <img src={svg} alt="Page Not Found"></img>
            </Box>
          </Grid>
        </Grid>
      </>
    </React.Fragment>
  );
};

export default PageNotFound;
